import { OctAutocompleteObject, OctInputSearch, OctLabel } from "@oceantech/oceantech-ui";
import { useState } from "react";
import { Stack } from "react-bootstrap";
import { PATIENT_STATUS } from "../constants";

type Props = {
	onSearch: (query: any) => void;
};

const PatientFilter = ({ onSearch }: Props) => {
	const [value, setValue] = useState<any>({
		isMedicalTreatmentCompleted: null,
		keyword: "",
	});

	return (
		<Stack direction="horizontal" className="spaces py-8 gap-8 justify-content-end">
			<OctLabel label="Trạng thái khám bệnh" />
			<OctAutocompleteObject
				name="isMedicalTreatmentCompleted"
				options={PATIENT_STATUS}
				value={value?.statusOption}
				onChange={(selectedOption) => {
					const newValue = {
						...value,
						isMedicalTreatmentCompleted: selectedOption?.value,
						statusOption: selectedOption,
					};
					setValue(newValue);
					onSearch(newValue);
				}}
				containerClassName="w-250px"
			/>
			<div className="w-25">
				<OctInputSearch
					onChange={(inputValue) => {
						if (inputValue === value?.keyword) return;

						const newValue = {
							...value,
							keyword: inputValue as string,
						};
						setValue(newValue);
						onSearch(newValue);
					}}
					handleSearch={() => {
						onSearch(value);
					}}
					placeholder="Tìm kiếm theo họ tên, mã bệnh nhân"
				/>
			</div>
		</Stack>
	);
};

export default PatientFilter;
